import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { PrivacyContent } from './PrivacyContent';
import { TermsContent } from './TermsContent';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-stone-900 text-stone-400 py-8" data-id="element-60">
        <div className="container mx-auto px-4 text-center space-y-4" data-id="element-61">
          <h3 className="text-white font-serif font-bold text-lg" data-id="element-62">
            Puentes de Palabras
          </h3>
          <p className="text-xs max-w-md mx-auto" data-id="element-63">
            Ayudando a familias a reencontrarse a través de un nuevo idioma
            emocional.
          </p>

          <div className="flex items-center justify-center gap-4 text-xs" data-id="element-64">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-orange-400 transition-colors underline underline-offset-4" data-id="element-65">
              Política de Privacidad
            </button>
            <span className="text-stone-600" data-id="element-66">•</span>
            <button onClick={() => setShowTerms(true)} className="hover:text-orange-400 transition-colors underline underline-offset-4" data-id="element-67">
              Términos y Condiciones
            </button>
          </div>

          <div className="pt-4 border-t border-stone-800 text-xs" data-id="element-68">
            <p data-id="element-69">
              &copy; {new Date().getFullYear()} Puentes de Palabras. Todos los
              derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-70">
        <PrivacyContent data-id="element-71" />
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-72">
        <TermsContent data-id="element-73" />
      </Modal>
    </>;
}